export const environment = {
  production: true,
};

export const BACKEND_URL = "https://api.backend.esano.ukw.de";
export const BACKEND_URL_MEDIA = BACKEND_URL + "/uploads/studies";
export const SUPPORT_MAIL = "support.esano-ukw@klips-ulm.de";
export const FEATURES = ["buddy", "jitai", "progress", "skills"];
export const APPSTORE_URL = "https://apps.apple.com/us/app/esano-research/id6670756895";
export const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=de.ukw.esano.research.android";
export const SHOW_APP_STORE_LINKS_IN_WEB_VERSION = false;
export const IS_UKW_VERSION = true;
